import english from '../en/cinema';

export default {
  ...english,
  cinema_referral: "รับรายได้จากการแชร์",
  cinema_referralDesc: "เชิญเพื่อนด้วยลิงก์ส่วนตัวของคุณและรับรางวัล",
  cinema_referralLinkTitle: "ลิงก์แนะนำของฉัน",
  cinema_referralLinkDesc: "การลงทะเบียนใหม่ผ่านลิงก์นี้จะถูกบันทึกให้กับคุณ",
  cinema_referralRulesTitle: "กติกาการแนะนำ",
  cinema_referralRulesCoins: "เมื่อเพื่อนลงทะเบียนผ่านลิงก์แนะนำของคุณ คุณอาจได้รับเหรียญรางวัล เหรียญสามารถใช้รับชมเนื้อหาบนแพลตฟอร์มเท่านั้น และไม่สามารถแลกเป็นเงินสดหรือถอนออกได้",
  cinema_referralRulesCommission: "เมื่อเพื่อนเติมเงิน คุณอาจได้รับค่าคอมมิชชันตามกฎเกณฑ์ที่กำหนด มีเพียงค่าคอมมิชชันจากการเติมเงินเท่านั้นที่สามารถถอนได้ เมื่อครบ 100 หยวน คุณจึงสามารถขอถอนเป็น USDT ได้",
  cinema_copyLink: "คัดลอกลิงก์",
  cinema_inviteCodeLabel: "รหัสแนะนำ",
  cinema_inviteRuleTitle: "รางวัลจากการแนะนำ",
  cinema_inviteRuleNormal: "สมาชิกจะได้รับ 20 เหรียญสำหรับทุกการลงทะเบียนที่สำเร็จ รางวัลจะถูกบันทึกในประวัติเหรียญ",
  cinema_distributorOverview: "ภาพรวมผู้แนะนำ",
  cinema_availableCommission: "พร้อมใช้งาน",
  cinema_totalCommission: "ยอดรวมค่าคอมมิชชัน",
  cinema_pendingWithdrawal: "กำลังรอการถอน",
  cinema_withdrawnAmount: "ถูกถอนแล้ว",
  cinema_firstLevelRate: "อัตราค่าคอมมิชชันระดับ 1",
  cinema_secondLevelRate: "อัตราค่าคอมมิชชันระดับ 2",
  cinema_todayBrowse: "ยอดวิว",
  cinema_todayRegister: "การลงทะเบียน",
  cinema_todayRecharge: "การเติมเงิน",
  cinema_todayRechargeAmount: "จำนวนเงินที่เติม",
  cinema_commissionAmount: "ค่าคอมมิชชัน",
  cinema_registerDetails: "การลงทะเบียน",
  cinema_rechargeDetails: "การเติมเงิน",
  cinema_inviteRewards: "รางวัลจากการแนะนำ",
  cinema_goWithdraw: "ถอน",
  cinema_noReferralData: "ยังไม่มีข้อมูลการแนะนำ",
  cinema_referralLoadFailed: "ไม่สามารถโหลดข้อมูลการแนะนำได้ โปรดลองอีกครั้ง",
  cinema_loginToPromote: "เข้าสู่ระบบเพื่อสร้างลิงก์แนะนำของคุณ",
  cinema_totalEarnings: "รายได้รวม",
  cinema_withdrawable: "สามารถถอนได้",
  cinema_frozen: "ถูกพักไว้",
  cinema_invitedCount: "ถูกเชิญ",
  cinema_coinUnit: "เหรียญ",
  cinema_people: "คน",
  cinema_conversionStats: "อัตราการแปลงจากการแนะนำ",
  cinema_allDatesTotal: "ยอดรวมทุกวัน",
  cinema_selectedDatesTotal: "ยอดรวมเฉพาะวันที่เลือก",
  cinema_conversionStatsDesc: "ยอดวิว ยอดลงทะเบียน ยอดเติมเงิน และค่าคอมมิชชันรายวัน",
  cinema_colDate: "วันที่",
  cinema_colPv: "ผู้เข้าชม",
  cinema_colBrowseCount: "ยอดวิว",
  cinema_colRegister: "การลงทะเบียน",
  cinema_colRechargeUsers: "ผู้ชำระเงิน",
  cinema_colRechargeOrders: "คำสั่งซื้อ",
  cinema_colPaidAmount: "จำนวนเงินที่ชำระ",
  cinema_colCommission: "ค่าคอมมิชชัน",
  cinema_colRegisterRate: "อัตราการลงทะเบียน",
  cinema_colRechargeRate: "อัตราการเติมเงิน",
  cinema_commissionRateTitle: "อัตราค่าคอมมิชชัน",
  cinema_currentRateLabel: "อัตราค่าคอมมิชชันปัจจุบัน",
  cinema_baseRate: "อัตราพื้นฐาน",
  cinema_currentRate: "อัตราปัจจุบัน",
  cinema_earningsRecord: "บันทึกผลตอบแทน",
  cinema_inviteDetail: "รายละเอียดการเชิญ",
  cinema_allEarnings: "ผลตอบแทนทั้งหมด",
  cinema_filterAll: "ทั้งหมด",
  cinema_filterPending: "รอการดำเนินการ",
  cinema_filterSettled: "ได้รับการชำระแล้ว",
  cinema_earningsDate: "วันที่",
  cinema_earningsType: "ประเภท",
  cinema_earningsUser: "ผู้ใช้",
  cinema_earningsAmount: "ผลตอบแทน",
  cinema_earningsStatus: "สถานะ",
  cinema_statusSettled: "ได้รับการชำระแล้ว",
  cinema_statusPending: "รอการดำเนินการ",
  cinema_noEarningsRecords: "ยังไม่มีบันทึก",
  cinema_referralUser: "ผู้ใช้",
  cinema_referralRegDate: "ลงทะเบียนแล้ว",
  cinema_referralRecharged: "ยอดเติมเงินรวม",
  cinema_referralEarned: "ผลตอบแทนของฉัน",
  cinema_startDate: "วันเริ่มต้น",
  cinema_endDate: "วันสิ้นสุด",
  cinema_query: "ค้นหา",
  cinema_dateRangeError: "วันเริ่มต้นต้องไม่เกินวันสิ้นสุด",
  cinema_brand: "Huangguo TV",
  cinema_language: "ภาษา",
  cinema_tagline: "ละครสั้นต้นฉบับ AI",
  cinema_navHome: "หน้าแรก",
  cinema_navCategories: "อันดับ",
  cinema_rankingTitle: "อันดับ",
  cinema_rankingAll: "ทั้งหมด",
  cinema_rankingLoading: "กำลังโหลดอันดับ...",
  cinema_rankingStats: "{{scope}} · {{period}} · {{count}} ซีรีส์ · {{views}} ครั้ง",
  cinema_rankingTotal: "ตลอดกาล",
  cinema_rankingMonth: "รายเดือน",
  cinema_rankingWeek: "รายสัปดาห์",
  cinema_rankingLatest: "ล่าสุด",
  cinema_rankingCreator: "ผู้สร้าง",
  cinema_creatorLabel: "ผู้สร้าง",
  cinema_rankingEmpty: "ยังไม่มีซีรีส์ที่ติดอันดับ",
  cinema_navMyList: "ยอดนิยม",
  cinema_soundGuideTitle: "แตะที่นี่เพื่อเปิดเสียง",
  cinema_soundGuideAction: "เปิดเสียง",
  cinema_soundGuideDismiss: "ปิดคู่มือเสียง",
  cinema_navHistory: "ประวัติ",
  cinema_navAds: "เหรียญ",
  cinema_adsTitle: "โฆษณาเด่น",
  cinema_adsSubtitle: "ค้นพบเนื้อหาเด่นเพิ่มเติม",
  cinema_adFeatured: "เด่น",
  cinema_adOpen: "ดูเลย",
  cinema_adsEmpty: "ไม่มีโฆษณาให้ชม",
  cinema_adsLoadFailed: "โหลดโฆษณาไม่สำเร็จ โปรดลองใหม่อีกครั้ง",
  cinema_earnTitle: "รับเหรียญ",
  cinema_earnSubtitle: "เช็กอินทุกวันและสะสมเหรียญ",
  cinema_earnBalance: "เหรียญของฉัน",
  cinema_checkInTitle: "เช็กอินรายวัน",
  cinema_checkInSubtitle: "รักษาสถิติเช็กอินต่อเนื่องเพื่อรับเหรียญเพิ่ม",
  cinema_checkInDay: "วันที่ {{day}}",
  cinema_checkInToday: "วันนี้",
  cinema_checkInClaim: "เช็กอินเพื่อรับเหรียญ {{points}}",
  cinema_checkInClaimed: "เช็กอินแล้ววันนี้",
  cinema_checkInLogin: "เข้าระบบเพื่อเช็กอิน",
  cinema_checkInSuccess: "เช็กอินเสร็จสมบูรณ์ คุณได้รับเหรียญ {{points}}",
  cinema_checkInFailed: "การเช็กอินล้มเหลว ตรวจสอบการเชื่อมต่อแล้วลองอีกครั้ง",
  cinema_checkInNoReward: "อุปกรณ์นี้ได้รับรางวัลเช็กอินประจำวันไปแล้ว",
  cinema_checkInStreak: "สถิติเช็กอินต่อเนื่องปัจจุบัน",
  cinema_checkInStreakValue: "{{days}} วัน",
  cinema_checkInTotal: "รวมที่ได้รับ",
  cinema_checkInTotalValue: "เหรียญ {{points}}",
  cinema_checkInLoadFailed: "โหลดสถานะการเช็คอินไม่สำเร็จ",
  cinema_retry: "ลองอีกครั้ง",
  cinema_moreEarnWays: "วิธีรับเพิ่มเติม",
  cinema_inviteEarnTitle: "เชิญเพื่อนและรับ",
  cinema_inviteEarnDesc: "รับเหรียญเมื่อเพื่อนลงทะเบียน",
  cinema_goInvite: "เชิญ",
  cinema_earnCoinsTitle: "รับเหรียญ",
  cinema_earnCoinsBalance: "เหรียญของฉัน",
  cinema_earnCoinsSignInStreak: "คุณเช็คอินมาแล้ว {{count}} วัน",
  cinema_earnCoinsCheckIn: "เช็คอิน",
  cinema_earnCoinsCheckedIn: "เช็คอินแล้ว",
  cinema_earnCoinsTomorrow: "กลับมาใหม่วันพรุ่งนี้",
  cinema_earnCoinsInviteTitle: "เชิญเพื่อนเพื่อรับ",
  cinema_earnCoinsInviteCode: "รหัสเชิญของฉัน",
  cinema_earnCoinsGoInvite: "เชิญเลย",
  cinema_earnCoinsLimitedTask: "ภารกิจจำกัด",
  cinema_earnCoinsTimeLeft: "นับถอยหลัง",
  cinema_earnCoinsNewbieTask: "ภารกิจสำหรับมือใหม่",
  cinema_earnCoinsDailyTask: "ภารกิจประจำวัน",
  cinema_earnCoinsRecommendations: "แนะนำ",
  cinema_earnCoinsAdTask: "ดูโฆษณา",
  cinema_earnCoinsAdTaskDesc: "ดูโฆษณาเพื่อรับเหรียญเพิ่ม",
  cinema_earnCoinsGoWatch: "ดูโฆษณา",
  cinema_earnCoinsTaskReward: "+{{reward}}",
  cinema_earnCoinsDayLabel: "วันที่ {{day}}",
  cinema_earnCoinsToday: "วันนี้",
  cinema_earnCoinsCoinUnit: "เหรียญ",
  cinema_earnCoinsAdCurrent: "ภารกิจปัจจุบัน",
  cinema_earnCoinsAdLocked: "ภารกิจล็อก",
  cinema_earnCoinsTaskCompleted: "เสร็จสมบูรณ์",
  cinema_limitedRechargeTaskTitle: "ทำการเติมเงินครั้งแรกให้สำเร็จภายใน 1 ชั่วโมง",
  cinema_limitedRechargeTaskAction: "เติมเงิน",
  cinema_claimReward: "ขอรับ",
  cinema_claiming: "กำลังขอรับ",
  cinema_taskClaimFailed: "การขอรับล้มเหลว กรุณาลองใหม่อีกครั้ง",
  cinema_bindEmailAction: "ผูกอีเมล",
  cinema_limitedRechargeTaskExpired: "หมดอายุ",
  cinema_watchHistory: "ประวัติการรับชม",
  cinema_navSearch: "ค้นหาซีรีส์...",
  cinema_login: "เข้าสู่ระบบ",
  cinema_vip: "เติมเงิน",
  cinema_heroPlay: "เล่นเลย",
  cinema_heroMore: "เรียนรู้เพิ่มเติม",
  cinema_hotRecommend: "กำลังมาแรง",
  cinema_carouselLoading: "กำลังโหลดเนื้อหาเด่น...",
  cinema_newRelease: "ผลงานใหม่",
  cinema_allSeries: "ซีรีส์ทั้งหมด",
  cinema_viewAll: "ดูทั้งหมด",
  cinema_episodes: "{{count}} ตอน",
  cinema_rating: "อันดับความนิยม {{score}}",
  cinema_views: "ยอดวิว {{count}}",
  cinema_play: "เล่น",
  cinema_continueWatch: "ดูต่อ",
  cinema_rewatch: "ดูซ้ำ",
  cinema_categoryAll: "ทั้งหมด",
  cinema_categoryUrban: "โรแมนติกเมือง",
  cinema_categorySuspense: "ระทึกขวัญ",
  cinema_categoryCostume: "ประวัติศาสตร์",
  cinema_categoryWorkplace: "สถานที่ทำงาน",
  cinema_categorySciFi: "ไซไฟ",
  cinema_categorySciFiRomance: "โรแมนติกไซไฟ",
  cinema_unlock: "ปลดล็อกตอน",
  cinema_unlockDesc: "การปลดล็อกตอนนี้ใช้เหรียญ {{cost}}",
  cinema_unlockConfirm: "ยืนยันและเล่น",
  cinema_cancel: "ยกเลิก",
  cinema_balance: "เงินคงเหลือ: เหรียญ {{coins}}",
  cinema_insufficient: "เหรียญไม่เพียงพอ กรุณาเติมเงิน",
  cinema_unlocked: "ปลดล็อกแล้ว",
  cinema_locked: "ล็อกไว้",
  cinema_episodeNumber: "ตอนที่ {{number}}",
  cinema_playing: "กำลังเล่น",
  cinema_backToList: "กลับไปยังรายการ",
  cinema_back: "ย้อนกลับ",
  cinema_noSeries: "ไม่มีซีรีส์ให้เลือก",
  cinema_seriesDesc: "เรื่องย่อ",
  cinema_episodeList: "ตอน",
  cinema_nextEpisode: "ถัดไป",
  cinema_episodeEnded: "ตอนจบแล้ว",
  cinema_nextEpisodePrompt: "ดำเนินต่อในตอนที่ {{number}}?",
  cinema_playNextEpisode: "เล่นตอนถัดไป",
  cinema_prevEpisode: "ก่อนหน้า",
  cinema_freeLabel: "ฟรี",
  cinema_vipLabel: "VIP",
  cinema_newLabel: "ใหม่",
  cinema_hotLabel: "ยอดนิยม",
  cinema_featuredBanner: "ต้องดูสัปดาห์นี้",
  cinema_watchNow: "ดูเลย",
  cinema_searchPlaceholder: "ค้นหาละคร",
  cinema_noResults: "ไม่พบซีรีส์",
  cinema_emptyMyList: "ยังไม่มีซีรีส์ในรายการของคุณ",
  cinema_emptyHistory: "ไม่มีประวัติการรับชม",
  cinema_addToMyList: "เพิ่มลงในรายการของฉัน",
  cinema_removeFromMyList: "ลบออกจากรายการของฉัน",
  cinema_clearAll: "ล้างทั้งหมด",
  cinema_footerCopy: "Huangguo TV — แพลตฟอร์มละครสั้นระดับพรีเมียม",
  cinema_footerWarning: "เนื้อหาถูกสร้างขึ้นโดย AI เพื่อความบันเทิงเท่านั้น โปรดปฏิบัติตามกฎหมายท้องถิ่น",
  cinema_myList: "รายการของฉัน",
  cinema_addedAt: "เพิ่มเมื่อ {{date}}",
  cinema_expand: "ขยาย",
  cinema_collapse: "ย่อ",
  cinema_historyAll: "ทั้งหมด",
  cinema_historyUnfinished: "ยังไม่จบ",
  cinema_historyFinished: "จบแล้ว",
  cinema_historyCount: "บันทึก {{count}} รายการ",
  cinema_noHistoryFilter: "ไม่มีบันทึกในหมวดหมู่นี้",
  cinema_finished: "จบแล้ว",
  cinema_watchedFull: "เสร็จสมบูรณ์",
  cinema_welcomeBack: "ยินดีต้อนรับกลับ",
  cinema_loginDesc: "เข้าสู่ระบบเพื่อปลดล็อกเนื้อหาเพิ่มเติม",
  cinema_phoneLogin: "เข้าสู่ระบบด้วยโทรศัพท์",
  cinema_emailLogin: "เข้าสู่ระบบด้วยอีเมล",
  cinema_phonePlaceholder: "ใส่หมายเลขโทรศัพท์",
  cinema_emailPlaceholder: "ใส่อีเมล",
  cinema_agreeTerms: "โดยการเข้าสู่ระบบ คุณยอมรับ",
  cinema_userAgreement: "ข้อตกลงผู้ใช้",
  cinema_privacyPolicy: "นโยบายความเป็นส่วนตัว",
  cinema_getCode: "รับรหัส",
  cinema_loginNow: "เข้าสู่ระบบตอนนี้",
  cinema_otherLogin: "วิธีเข้าสู่ระบบอื่นๆ",
  cinema_loggingIn: "กำลังเข้าสู่ระบบ...",
  cinema_loginSuccess: "เข้าสู่ระบบสำเร็จ",
  cinema_loginRedirect: "กำลังเปลี่ยนเส้นทางไปยังโปรไฟล์...",
  cinema_profile: "โปรไฟล์",
  cinema_memberLabel: "สมาชิก",
  cinema_dealerLabel: "ตัวแทนจำหน่าย",
  cinema_coinAmount: "{{count}} เหรียญ",
  cinema_profileAccount: "บัญชี",
  cinema_profileContent: "เนื้อหา",
  cinema_profileSettings: "การตั้งค่า",
  cinema_editProfile: "แก้ไขโปรไฟล์",
  cinema_myCoins: "เหรียญของฉัน",
  cinema_myPurchases: "ซื้อแล้ว",
  cinema_downloads: "การดาวน์โหลด",
  cinema_playbackSettings: "การตั้งค่าการเล่น",
  cinema_notifications: "การแจ้งเตือน",
  cinema_cacheManage: "การจัดการแคช",
  cinema_about: "ติดต่อเรา",
  cinema_contactUnavailable: "บริการลูกค้าไม่พร้อมให้บริการ โปรดลองใหม่อีกครั้งในภายหลัง",
  cinema_watchedHours: "ชั่วโมงรับชม",
  cinema_collectionCount: "คอลเลกชัน",
  cinema_logout: "ออกจากระบบ",
  cinema_logoutConfirm: "ยืนยันการออกจากระบบ?",
  cinema_logoutConfirmDesc: "คุณจะต้องเข้าสู่ระบบอีกครั้งเพื่อใช้ฟีเจอร์ครบถ้วน",
  cinema_version: "เวอร์ชัน {{version}}",
  cinema_rechargeTitle: "เติมเงิน",
  cinema_rechargeSubtitle: "เลือกแผนเติมเงิน",
  cinema_rechargeVpnWarning: "VPN หรือพร็อกซีอาจทำให้เกิดการควบคุมความเสี่ยงด้านการชำระเงิน ส่งผลให้หน้าชำระเงินไม่เปิดหรือการชำระเงินล้มเหลว",
  cinema_rechargeVpnGuideTitle: "ปิด VPN ของคุณก่อนทำการชำระเงิน",
  cinema_rechargeVpnInstruction: "หลังจากปิด VPN แล้ว ให้คลิกปุ่มด้านล่างเพื่อดำเนินการตามวิธีการชำระเงินที่คุณเลือกต่อไป",
  cinema_rechargeVpnContinue: "VPN ปิดแล้ว ดำเนินการชำระเงินต่อ",
  cinema_rechargeRMB: "เติมเงินด้วย RMB",
  cinema_rechargeUSDT: "เติมเงินด้วย USDT",
  cinema_rechargeRecommended: "แนะนำ",
  cinema_rechargeCoins: "เหรียญ",
  cinema_rechargeBonus: "โบนัส +{{points}}",
  cinema_rechargeCredited: "รับ {{points}}",
  cinema_firstRechargeBannerTitle: "โบนัสเติมเงินครั้งแรก! รางวัลพิเศษสำหรับยอดเงินทุกจำนวน",
  cinema_firstRechargeSelectedBonus: "เหรียญ +{{points}}",
  cinema_firstRechargeLimitedTitle: "โบนัสเติมเงินครั้งแรกแบบจำกัด",
  cinema_dailyRechargeLimitedTitle: "โบนัสเติมเงินแบบจำกัด",
  cinema_firstRechargeLimitedBonus: "เพิ่ม {{percent}}% สำหรับยอดเงินทุกจำนวน",
  cinema_rechargePayMethod: "วิธีการชำระเงิน",
  cinema_rechargePay: "ชำระเงิน",
  cinema_rechargeNoPackages: "ขณะนี้ยังไม่มีแผนเติมเงินให้บริการ",
  cinema_paymentUnavailable: "ขณะนี้ยังไม่สามารถชำระเงินได้ กรุณาติดต่อฝ่ายสนับสนุน",
  cinema_follow: "ติดตาม",
  cinema_collect: "เก็บรวบรวม",
  cinema_share: "แชร์",
  cinema_loading: "กำลังโหลด...",
  cinema_favorites: "รายการโปรด",
  cinema_emptyFavorites: "ยังไม่มีซีรีส์โปรด",
  cinema_emptyPurchases: "ยังไม่มีซีรีส์ที่ซื้อมา",
  cinema_clearAllConfirm: "ล้างประวัติการรับชมทั้งหมดหรือไม่?",
  cinema_episodesUnit: "ตอน",
  cinema_lastWatched: "ตอนสุดท้ายที่รับชม {{episode}}",
  cinema_purchasedEpisodes: "ปลดล็อกแล้ว {{count}} ตอน",
  cinema_account: "บัญชี",
  cinema_accountName: "ชื่อที่แสดง",
  cinema_accountEmail: "อีเมล",
  cinema_shareCode: "แบ่งปันรหัส",
  cinema_saveProfile: "บันทึกโปรไฟล์",
  cinema_profileSaved: "บันทึกโปรไฟล์เรียบร้อยแล้ว",
  cinema_profileSaveFailed: "บันทึกโปรไฟล์ล้มเหลว",
  cinema_accountInfo: "ข้อมูลพื้นฐาน",
  cinema_changePassword: "เปลี่ยนรหัสผ่าน",
  cinema_newPassword: "รหัสผ่านใหม่",
  cinema_confirmPassword: "ยืนยันรหัสผ่านใหม่",
  cinema_passwordHint: "ใช้ตัวอักษรอย่างน้อย 6 ตัว",
  cinema_passwordMismatch: "รหัสผ่านไม่ตรงกัน",
  cinema_passwordSaved: "อัปเดตรหัสผ่านเรียบร้อยแล้ว",
  cinema_passwordSaveFailed: "อัปเดตรหัสผ่านล้มเหลว",
  cinema_savePassword: "บันทึกรหัสผ่าน",
  cinema_pointsBalance: "ยอดเหรียญคงเหลือ",
  cinema_coinLedger: "สมุดบัญชีเหรียญ",
  cinema_businessReference: "อ้างอิง",
  cinema_emptyPointLogs: "ยังไม่มีประวัติเหรียญ",
  cinema_pointLog_registerReward: "รางวัลลงทะเบียน",
  cinema_pointLog_appFirstLoginReward: "รางวัลเข้าสู่ระบบแอปครั้งแรก",
  cinema_pointLog_inviteReward: "รางวัลเชิญชวน",
  cinema_pointLog_dailyCheckIn: "รางวัลเช็กอินประจำวัน",
  cinema_pointLog_limitedRechargeTask: "รางวัลภารกิจเติมเงินครั้งแรกแบบจำกัด",
  cinema_pointLog_emailBindingTask: "รางวัลภารกิจผูกอีเมล",
  cinema_pointLog_dailyUnlockTask: "รางวัลภารกิจปลดล็อกตอนรายวัน",
  cinema_bindEmailTaskTitle: "ผูกอีเมล",
  cinema_dailyUnlockTaskTitle: "ปลดล็อกตอนใหม่ {{count}} ตอน",
  cinema_unlockAction: "ไปปลดล็อก",
  cinema_dailyTaskProgress: "ความคืบหน้าวันนี้ {{current}}/{{target}} (ไม่นับตอนที่ 1)",
  cinema_pointLog_firstEpisodeUnlock: "ปลดล็อกตอนแรกผ่าน",
  cinema_pointLog_episodeUnlock: "ปลดล็อกตอน",
  cinema_pointLog_recharge: "เติมเงินเข้าบัญชีแล้ว",
  cinema_pointLog_firstRechargeBonus: "โบนัสเติมเงินครั้งแรก",
  cinema_pointLog_dailyRechargeBonus: "โบนัสเติมเงินจำกัดเวลา",
  cinema_pointLog_adminAdjust: "การปรับแต่งโดยแอดมิน",
  cinema_pointLog_other: "เงินทอนเหรียญ",
  cinema_pointBiz_register: "การลงทะเบียน",
  cinema_pointBiz_registerBackfill: "การคืนรางวัลจากการลงทะเบียน",
  cinema_pointBiz_appFirstLogin: "การเข้าสู่ระบบแอปครั้งแรก",
  cinema_pointBiz_inviteRegister: "การลงทะเบียนผ่านคำเชิญ",
  cinema_pointBiz_dailyCheckIn: "การเช็กอินรายวัน",
  cinema_pointBiz_legacyLimitedRechargeTask: "ภารกิจเติมเงินภายใน 24 ชั่วโมง",
  cinema_pointBiz_limitedRechargeTask: "ภารกิจเติมเงินครั้งแรกภายใน 1 ชั่วโมง",
  cinema_pointBiz_emailBindingTask: "ภารกิจผูกอีเมล",
  cinema_pointBiz_unlockThreeEpisodes: "ภารกิจปลดล็อกตอน 3 ตอนต่อวัน",
  cinema_pointBiz_unlockFiveEpisodes: "ภารกิจปลดล็อกตอน 5 ตอนต่อวัน",
  cinema_pointBiz_episodeUnlock: "ปลดล็อกตอน",
  cinema_pointBiz_rechargeOrder: "คำสั่งเติมเงิน",
  cinema_pointBiz_adminAdjust: "การปรับแต่งโดยแอดมิน",
  cinema_pointBiz_other: "ธุรกิจอื่น ๆ",
  cinema_playbackAutoplay: "เล่นตอนถัดไปอัตโนมัติ",
  cinema_playbackAutoplayDesc: "ดำเนินการต่อโดยอัตโนมัติเมื่อจบตอน",
  cinema_aboutDesc: "แฟนตาซีของฉันนำเสนอบทละครสั้นที่อัปเดตอย่างต่อเนื่อง",
  cinema_rechargeOrders: "บัญชีการเติมเงิน",
  cinema_myRechargeRecords: "ดูประวัติการเติมเงินของฉัน",
  cinema_totalInvites: "จำนวนคำเชิญทั้งหมด",
  cinema_distributionStats: "สถิติโปรโมชัน",
  cinema_distributionStatsDesc: "ตรวจสอบยอดเข้าชม การลงทะเบียน การเติมเงิน และค่าคอมมิชชันแยกตามวันที่",
  cinema_summaryDate: "วันที่",
  cinema_summaryBrowse: "ยอดเข้าชม",
  cinema_summaryRegister: "การลงทะเบียน",
  cinema_summaryRechargeCount: "การเติมเงิน",
  cinema_conversionRate: "อัตราการแปลงเป็นผู้ใช้งาน",
  cinema_commissionRatio: "อัตราค่าคอมมิชชัน",
  cinema_browseDetails: "ดูรายละเอียด",
  cinema_browseTime: "ระยะเวลาเข้าชม",
  cinema_browseDrama: "บทละคร",
  cinema_browseRegion: "ภูมิภาค",
  cinema_noBrowseData: "ยังไม่มีบันทึกการเข้าชม",
  cinema_noSummaryData: "ยังไม่มีข้อมูลสรุป",
  cinema_rewarded: "ได้รับรางวัล",
  cinema_registered: "ลงทะเบียนแล้ว",
  cinema_close: "ปิด",
  cinema_emptyRechargeOrders: "ยังไม่มีบันทึกการเติมเงิน",
  cinema_rechargeRecords: "สมุดบัญชีการเติมเงิน",
  cinema_commissionRecords: "สมุดบัญชีค่าคอมมิชชัน",
  cinema_rechargeTime: "เวลาเติมเงิน",
  cinema_paymentMethod: "วิธีการชำระเงิน",
  cinema_paymentStatus: "สถานะการชำระเงิน",
  cinema_orderNo: "หมายเลขคำสั่งซื้อ",
  cinema_noRechargeRecords: "ยังไม่มีบันทึกการเติมเงิน",
  cinema_commissionTime: "เวลาค่าคอมมิชชัน",
  cinema_commissionLevel: "ระดับค่าคอมมิชชัน",
  cinema_commissionRate: "อัตราค่าคอมมิชชัน",
  cinema_noCommissionRecords: "ยังไม่มีบันทึกค่าคอมมิชชัน",
  cinema_search: "ค้นหา",
  cinema_reset: "รีเซ็ต",
  cinema_previousPage: "ก่อนหน้า",
  cinema_nextPage: "ถัดไป",
  cinema_paymentStatus_created: "สร้างแล้ว",
  cinema_paymentStatus_pending: "กำลังรอการชำระเงิน",
  cinema_paymentStatus_paid: "เติมเงินสำเร็จ",
  cinema_paymentStatus_failed: "การชำระเงินล้มเหลว",
  cinema_paymentStatus_closed: "ปิดแล้ว",
  cinema_paymentStatus_expired: "หมดอายุแล้ว",
  cinema_paymentAwaiting: "สร้างคำสั่งซื้อแล้ว โปรดชำระเงินให้ครบถ้วนที่หน้าชำระเงิน หากการชำระเงินล้มเหลว โปรดตรวจสอบว่า VPN ของคุณถูกปิดอยู่",
  cinema_usdtAddress: "ที่อยู่ผู้รับ",
  cinema_usdtNetwork: "ใช้ได้เฉพาะเครือข่าย TRC20",
  cinema_copy: "คัดลอก",
  cinema_copied: "คัดลอกแล้ว",
  cinema_playerSettings: "การตั้งค่าการเล่น",
  cinema_playerQuality: "คุณภาพ",
  cinema_playerSpeed: "ความเร็วในการเล่น",
  cinema_playerAuto: "อัตโนมัติ",
  cinema_playerSource: "ต้นฉบับ",
  cinema_playerSubtitles: "คำบรรยาย",
  cinema_subtitleAuto: "อัตโนมัติ",
  cinema_subtitleOff: "ปิดคำบรรยาย",
  cinema_appDownloadTitle: "รับชมตอนถัดไปได้อย่างเสถียรมากขึ้นในแอป",
  cinema_appDownloadDesc: "จดจำความคืบหน้าของคุณและรับการแจ้งเตือนเกี่ยวกับการอัปเดต",
  cinema_appDownloadReward: "ดาวน์โหลดแอปและรับเหรียญโบนัส {{points}} เมื่อเข้าสู่ระบบครั้งแรก!",
  cinema_homeAppDownloadReward: "รับเหรียญโบนัส {{points}} เมื่อเข้าสู่ระบบผ่านแอป!",
  cinema_shareEarnPoints: "แชร์ & รับ",
  cinema_shareLinkLabel: "แชร์ลิงก์",
  cinema_shareRewardUnlimited: "รับเหรียญ {{points}} สำหรับผู้ใช้รายใหม่ทุกคนที่สมัครผ่านลิงก์ของคุณ โดยไม่มีขีดจำกัด!",
  cinema_loginForShareLink: "เข้าสู่ระบบเพื่อรับลิงก์แชร์ของคุณ",
  cinema_viewReferralStats: "ดูสถิติการแนะนำ",
  cinema_episodeFinished: "ตอนจบแล้ว",
  cinema_unlockNextEpisode: "ปลดล็อกตอนถัดไป",
  cinema_changeDrama: "เปลี่ยนวิดีโอ",
  cinema_allUnlocked: "ปลดล็อกทั้งหมดแล้ว",
  cinema_appDownloadButton: "ดาวน์โหลดแอป",
  cinema_appDownloadUnavailable: "ยังไม่สามารถดาวน์โหลดได้ในขณะนี้",
  cinema_rechargeAppPromptTitle: "ดาวน์โหลดแอปเพื่อรับเหรียญโบนัส",
  cinema_rechargeAppPromptReward: "ดาวน์โหลดและเข้าสู่ระบบเพื่อรับเหรียญพิเศษ {{points}}!",
  cinema_rechargeAppPromptDesc: "เพลิดเพลินกับการเล่นที่เสถียรมากขึ้นและการบันทึกความคืบหน้าในการรับชมอัตโนมัติในแอป",
  cinema_appDownloadQr: "สแกนเพื่อดาวน์โหลดแอป",
  cinema_ageGateBadge: "การยืนยันอายุ",
  cinema_ageGateTitle: "ประกาศเนื้อหาสำหรับผู้ใหญ่",
  cinema_ageGateDescription: "เว็บไซต์นี้มีเนื้อหาที่สร้างขึ้นโดย AI ในเชิงสมมติ และมีไว้สำหรับผู้ใหญ่เท่านั้น หากดำเนินการต่อ แสดงว่าคุณยืนยันว่ามีอายุอย่างน้อย 18 ปี และยอมรับที่จะปฏิบัติตามกฎหมายในพื้นที่ของคุณ",
  cinema_ageGateUnderage: "หากคุณมีอายุต่ำกว่า 18 ปี โปรดออกจากเว็บไซต์นี้ทันที",
  cinema_ageGateConfirm: "ฉันมีอายุ 18 ปีขึ้นไป — เข้าสู่เว็บไซต์",
  cinema_creatorCenter: "ศูนย์ครีเอเตอร์",
  cinema_creatorCenterDesc: "สร้างเรื่องราวของคุณ แบ่งปันโลกของคุณ",
  cinema_creatorCenterNote: "หมายเหตุ: ผลงานที่ไม่ใช่ของตัวเองต้องปราศจากลายน้ำ",
  cinema_creatorMemberReady: "คุณเป็นสมาชิก VIP สมัครเพียงคลิกเดียว",
  cinema_creatorBecome: "เป็นผู้สร้างสรรค์",
  cinema_creatorGateDesc: "นำเรื่องราวของคุณมาสู่ Huangguo TV เมื่อได้รับอนุมัติแล้ว ผลงานของคุณจะถูกเผยแพร่บนแพลตฟอร์มให้ผู้ชมนับล้านได้รับชมพร้อมกับโอกาสสร้างรายได้จากการสมัครสมาชิกแบบพรีเมียม",
  cinema_creatorApplyBtn: "สมัครเป็นผู้สร้างสรรค์",
  cinema_creatorBenefitTitle: "สิทธิประโยชน์สำหรับผู้สร้างสรรค์",
  cinema_creatorBenefit1: "ผลงานของคุณจะถูกจัดทำเป็นแท็ก “ต้นฉบับ” อย่างเฉพาะเจาะจง",
  cinema_creatorBenefit2: "ติดตามยอดวิว การสมัครสมาชิก และส่วนแบ่งรายได้แบบเรียลไทม์",
  cinema_creatorBenefit3: "ปลดล็อกเครื่องมือสร้างสรรค์และทรัพยากรโปรโมชันเพิ่มเติม",
  cinema_creatorReviewTip: "ใบสมัครและผลงานจะได้รับการตรวจสอบโดยแพลตฟอร์ม และต้องปฏิบัติตามแนวทางชุมชน",
  cinema_creatorLevel: "ผู้สร้างสรรค์ที่ผ่านการรับรอง",
  cinema_creatorOriginal: "ต้นฉบับ",
  cinema_creatorSince: "ผู้สร้างสรรค์ตั้งแต่",
  cinema_creatorAddWork: "อัปโหลดผลงานใหม่",
  cinema_creatorTabOverview: "ภาพรวม",
  cinema_creatorTabWorks: "ผลงานของฉัน",
  cinema_creatorTabUpload: "อัปโหลด",
  cinema_creatorTabPlatform: "สตูดิโอ",
  cinema_creatorSubmitted: "ส่งแล้ว รอการตรวจสอบ",
  cinema_creatorStatViews: "ยอดวิวรวม",
  cinema_creatorStatSubs: "จำนวนผู้ติดตามรวม",
  cinema_creatorStatRevenue: "รายได้รวม",
  cinema_creatorStatWithdraw: "สามารถถอนได้",
  cinema_creatorStatWorks: "ผลงาน",
  cinema_creatorStatReview: "กำลังตรวจสอบ",
  cinema_creatorStatRejected: "ถูกปฏิเสธ",
  cinema_creatorTopWork: "ผลงานที่มีประสิทธิภาพดีที่สุด",
  cinema_creatorViews: "ยอดวิว",
  cinema_creatorSubscriptions: "ผู้ติดตาม",
  cinema_creatorShare: "รายได้",
  cinema_creatorNoPublished: "ยังไม่มีผลงานเผยแพร่",
  cinema_creatorFilterPublished: "เผยแพร่แล้ว",
  cinema_creatorFilterReview: "กำลังตรวจสอบ",
  cinema_creatorFilterRejected: "ถูกปฏิเสธ",
  cinema_creatorWorksTitle: "ผลงานของฉัน",
  cinema_creatorNoWorks: "ยังไม่มีผลงาน โปรดอัปโหลดผลงานแรกของคุณ",
  cinema_creatorGoUpload: "อัปโหลดเลย",
  cinema_creatorStatusPublished: "เผยแพร่แล้ว",
  cinema_creatorStatusReview: "กำลังตรวจสอบ",
  cinema_creatorStatusApproved: "รอการแปลงโค้ด",
  cinema_creatorStatusTranscoding: "กำลังแปลงโค้ด",
  cinema_creatorStatusReady: "รอการเผยแพร่",
  cinema_creatorStatusTranscodeFailed: "การแปลงโค้ดล้มเหลว",
  cinema_creatorStatusPublishFailed: "การเผยแพร่ล้มเหลว",
  cinema_creatorStatusRejected: "ถูกปฏิเสธ",
  cinema_creatorPublishedOn: "เผยแพร่เมื่อ",
  cinema_creatorSubmittedOn: "ส่งเมื่อ",
  cinema_creatorRejectedTip: "ถูกปฏิเสธ · ส่งเมื่อ",
  cinema_creatorWorkName: "ชื่อผลงาน",
  cinema_creatorWorkNamePh: "ใส่ชื่อผลงาน",
  cinema_creatorCategory: "หมวดหมู่",
  cinema_creatorCover: "หน้าปก",
  cinema_creatorCoverHint: "อัปโหลดรูปภาพหน้าปกแนวตั้งหนึ่งภาพ",
  cinema_creatorCoverUrlPh: "วางลิงก์รูปภาพ (ไม่บังคับ)",
  cinema_creatorSynopsis: "เรื่องย่อ",
  cinema_creatorSynopsisPh: "อธิบายเรื่องราวของคุณในหนึ่งหรือสองประโยค…",
  cinema_creatorEpisodeTitle: "ตอน",
  cinema_creatorEpisodeDesc: "เพิ่มชื่อเรื่องและอัปโหลดวิดีโอ MP4 หรือ MOV หนึ่งไฟล์สำหรับทุกตอน",
  cinema_creatorEpisodeTitlePh: "ชื่อตอน",
  cinema_creatorEpisodeDurPh: "ความยาว (นาที)",
  cinema_creatorAddEpisode: "เพิ่มตอน",
  cinema_creatorEpShort: "ตอน {{count}}",
  cinema_creatorEpisodeUpload: "อัปโหลดวิดีโอ",
  cinema_creatorEpisodeUploading: "กำลังอัปโหลด…",
  cinema_creatorEpisodeReplace: "เปลี่ยนวิดีโอ",
  cinema_creatorEpisodeMp4Only: "รองรับไฟล์ .mp4 และ .mov ขนาดไม่เกิน 100 MB ต่อไฟล์",
  cinema_creatorEpisodeTypeError: "แต่ละตอนต้องเป็นวิดีโอในรูปแบบ .mp4 หรือ .mov",
  cinema_creatorEpisodeSizeError: "ขนาดไฟล์วิดีโอของแต่ละตอนต้องไม่เกิน 100 MB",
  cinema_creatorEpisodeUploadFailed: "การอัปโหลดตอนล้มเหลว กรุณาลองใหม่อีกครั้ง",
  cinema_creatorEpisodeRequired: "เพิ่มชื่อเรื่องและอัปโหลดวิดีโอ MP4 หรือ MOV สำหรับทุกตอน",
  cinema_creatorRequired: "โปรดกรอกชื่อเรื่องและเลือกภาพปกก่อน",
  cinema_creatorWorkNameRequired: "ใส่ชื่อผลงาน",
  cinema_creatorCategoryRequired: "เลือกหมวดหมู่",
  cinema_creatorCoverRequired: "อัปโหลดภาพปก",
  cinema_creatorEpisodeTitleRequired: "ใส่ชื่อตอน",
  cinema_creatorEpisodeVideoRequired: "อัปโหลดวิดีโอ MP4 หรือ MOV สำหรับตอนนี้",
  cinema_creatorSubmit: "ส่งเพื่อตรวจสอบ",
  cinema_creatorPlatformTag: "ผู้สร้างแนะนำ",
  cinema_creatorPlatformTitle: "แพลตฟอร์มเครื่องมือสร้างสรรค์",
  cinema_creatorPlatformDesc: "ไปยังแพลตฟอร์มการสร้างสรรค์อย่างเป็นทางการ เพื่อเครื่องมือระดับมืออาชีพ แรงบันดาลใจในการเขียนบท และทรัพยากรต่าง ๆ ที่จะช่วยให้เรื่องราวของคุณกลายเป็นจริงและเผยแพร่ได้",
  cinema_creatorPlatformPoint1: "สคริปต์และไอเดียจาก AI",
  cinema_creatorPlatformPoint2: "เครื่องมือสร้างสรรค์และอัปโหลดระดับมืออาชีพ",
  cinema_creatorPlatformPoint3: "การสนับสนุนด้านทราฟฟิกและการจ่ายเงิน",
  cinema_creatorPlatformOpen: "ไปยังแพลตฟอร์มการสร้างสรรค์",
  cinema_creatorEarnBannerTitle: "พาเรื่องราวของคุณสู่จอภาพยนตร์",
  cinema_creatorEarnBannerDesc: "กลายเป็นผู้สร้าง อัปโหลดผลงาน และสร้างรายได้จากยอดวิว การสมัครสมาชิก และส่วนแบ่งรายได้",
  cinema_creatorEarnBannerBtn: "เปิดศูนย์ผู้สร้าง",
  cinema_creatorApplyFailed: "การสมัครล้มเหลว กรุณาลองใหม่อีกครั้ง",
  cinema_creatorSubmitFailed: "การส่งล้มเหลว กรุณาลองใหม่อีกครั้ง",
  cinema_creatorSubmitting: "กำลังส่ง…",
  cinema_creatorCategoryEmpty: "ไม่มีหมวดหมู่ให้เลือก",
  cinema_creatorCoverUpload: "อัปโหลดภาพปก",
  cinema_creatorCoverUploading: "กำลังอัปโหลด…",
  cinema_creatorCoverChoose: "เลือกภาพ",
  cinema_creatorCoverReplace: "เปลี่ยนภาพ",
  cinema_creatorCoverRemove: "ลบออก",
  cinema_creatorCoverFormat: "JPG, PNG, WebP หรือ GIF ขนาดไม่เกิน 10 MB รูปภาพเพียงหนึ่งภาพเท่านั้น",
  cinema_creatorCoverTypeError: "เลือกรูปภาพ JPG, PNG, WebP หรือ GIF",
  cinema_creatorCoverSizeError: "รูปภาพปกต้องมีขนาดไม่เกิน 10 MB",
  cinema_creatorCoverUploadFailed: "การอัปโหลดรูปภาพปกล้มเหลว โปรดลองอีกครั้ง",
  cinema_creatorUploadNoticeTitle: "หลักเกณฑ์การอัปโหลด",
  cinema_creatorUploadNotice1: "ทรัพยากรที่อัปโหลดทั้งหมด ไม่ว่าจะเป็นของเดิมหรือของผู้อื่น ต้องปราศจากลายน้ำ",
  cinema_creatorUploadNotice2: "ผู้สร้างสรรค์ดั้งเดิมสามารถติดต่อทีมธุรกิจของเราเพื่อลงทะเบียนสิทธิในลิขสิทธิ์ได้",
  cinema_creatorUploadNotice3: "ราคาสำหรับตอนสุดท้ายถูกกำหนดโดยแพลตฟอร์ม",
  cinema_creatorUploadNotice4: "แต่ละตอนต้องมีความยาวอย่างน้อย 150 วินาที",
  cinema_creatorUploadNoticeConfirm: "ฉันเข้าใจ ดำเนินการต่อ",
  cinema_navProfile: "ของฉัน",
};
